module.exports = __webpack_public_path__ + "static/media/harry-potter-directory.857745f9.png";